import axios from 'axios';
import router from '../router/index';
import store from '../store/index';

const baseURL = process.env.VUE_APP_API_URL;
const instance = axios.create({ baseURL });

instance.interceptors.request.use((config) => {
  const access_token = localStorage.getItem('PERSONNEL_ACCESS_TOKEN');

  store.commit('SET_LOADING', true);

  if(access_token) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }

  return config;
});

instance.interceptors.response.use((response) => {
  store.commit('SET_LOADING', false);
  return response;
}, (error) => {
  store.commit('SET_LOADING', false);
  if(401 === error.response.status) {
    if(error.response.data) {
      if(error.response.data.code && error.response.data.code === 2) {
        return Promise.reject(error);
      } else {
        store.dispatch('auth/destroyToken');
        router.push('/login').catch(() => {});
        return Promise.reject(error);
      }
    }
  }
  
  
  // else {
  return Promise.reject(error);
  // }
})

export default instance;
